import React from 'react';
import { withRouter } from 'react-router';
import Header from './Header';

const HeaderContainer = (props) => (<Header {...props} />);

export default withRouter(HeaderContainer);
